<script>
  export let toolName = "Tool Name";
</script>

<div
  class="flex flex-col align-center justify-center text-center gap-12 relative p-12"
>
  <div class="text-balloon-icon-wrapper hide-on-mobile">
    <div class="text-balloon-icon-container">
      <svg
        class="text-balloon-icon"
        aria-hidden="true"
        width="43"
        height="36"
        viewBox="0 0 43 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.0484 9.69345L39.0485 9.69359C41.5594 13.3883 42.1516 18.1663 41.1339 22.5373C40.116 26.9093 37.5035 30.8085 33.6884 32.7814C31.6544 33.8329 28.9544 34.421 26.086 34.5732C23.2226 34.7252 20.2278 34.4409 17.6235 33.777C17.5303 33.7533 17.4388 33.7299 17.3488 33.707C14.9638 33.0986 13.6982 32.7757 12.317 32.7203C10.9435 32.6652 9.46041 32.875 6.63466 33.2746C6.52838 33.2896 6.42019 33.3049 6.31005 33.3205C4.9359 33.5144 3.77794 33.5799 2.87181 33.5333C1.94608 33.4858 1.35326 33.3239 1.04892 33.1245C0.90738 33.0317 0.858247 32.9508 0.840374 32.8959C0.823025 32.8427 0.813969 32.7494 0.877823 32.5894C1.01668 32.2414 1.44031 31.7309 2.31012 31.0747L4.60611 29.3427L4.93404 29.0953L4.75501 28.7256L2.60212 24.2798C2.02561 23.0878 1.49738 21.642 1.11378 20.275C0.727618 18.8988 0.5 17.6448 0.5 16.8265C0.5 10.2059 5.99746 3.64965 13.9175 1.09541C16.026 0.416147 19.0837 0.33069 22.3254 0.774673C25.5578 1.21738 28.9125 2.17824 31.5989 3.53951C34.5433 5.03232 37.615 7.58282 39.0484 9.69345Z"
          stroke="black"
        ></path>
      </svg>
    </div>
  </div>
  <div class="phone-icon-wrapper hide-on-mobile">
    <div class="phone-icon-container">
      <svg
        class="phone-icon"
        aria-hidden="true"
        width="26"
        height="61"
        viewBox="0 0 26 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.10854 46.8317C1.4473 42.8849 4.72124 40.186 7.56163 41.5119C12.6965 43.9094 16.7749 37.3037 16.0438 27.7719C15.5602 21.452 14.286 20.0211 8.96191 19.822C6.49337 19.7306 3.97448 18.9706 3.36332 18.1356C2.75173 17.2998 2.26478 13.691 2.2817 10.1142C2.3175 2.1123 4.05102 0.266038 11.2133 0.598877C17.3308 0.883302 19.217 2.23302 22.0345 8.34074C29.5636 24.6571 25.2659 54.7716 14.6949 59.7649C11.5727 61.2396 6.39925 61.0645 3.45408 59.3833C1.41656 58.2212 1.147 57.6529 0.989238 54.1862C0.891296 52.0449 0.945174 48.7359 1.10854 46.8317Z"
          fill="black"
        ></path>
      </svg>
    </div>
  </div>
  <h2>Join DialMyCalls <br /> To Keep Using “{toolName}”</h2>
  <p>
    As low as $7.49/mo gets you unlimited access to all our AI tools, PLUS 1
    free phone number to send and receive text messages and phone calls.
  </p>
  <a href="/pricing" class="button mt-10"> Get Started Now</a>
</div>

<style>
  .text-balloon-icon {
    height: 46px;
    width: 50px;
    margin-top: 4px;
    filter: drop-shadow(0px 6px 3px rgba(0, 0, 0, 0.101961));
  }

  .text-balloon-icon path {
    fill: white;
    stroke: none;
  }

  .text-balloon-icon-container {
    background: #28a74540;
    padding: 6px 8px;
    border-radius: 8px;
  }

  .text-balloon-icon-wrapper {
    position: absolute;
    top: -5px;
    right: -1px;
    transform: rotate(346deg);
  }

  .phone-icon {
    height: 50px;
    width: 50px;
    transform: rotate(28deg) translate(1px, 0px);
    filter: drop-shadow(4px -1px 3px rgba(0, 0, 0, 0.101961));
  }

  .phone-icon path {
    fill: white;
  }

  .phone-icon-container {
    transform: rotate(106deg);
    background: #daecf9b3;
    padding: 6px;
    border-radius: 8px;
  }

  .phone-icon-wrapper {
    position: absolute;
    left: -2px;
    bottom: -6px;
  }
</style>
